import Vue from 'vue'
import Vuex from 'vuex'
import Axios from 'axios'
import { SET_DATA_SAMPLE_NOTIFY } from './mutations.type'
import { GET_SAMPLE_NOTIFY } from './actions.type'
import ApiService from '../common/api.service'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    api: 'https://info-sites.mskobr.ru',
    apiGo: 'https://api-typalsites.mskobr.ru',
    rightsDocs: '/api/ekis/rights/docs.json',
    akkred: '/api/ekis/akkred.json',
    localDocs: '/api/ekis-docs/local/docs.json',
    paidAdd: '/api/ekis-docs/paid/add.json',
    collAgreement: '/api/ekis-docs/file/by/name.json',
    parentPay: '/api/ekis-docs/parent/pay.json',
    fileBySlug: '/api/v0/files_by_slug/',
    finDocs: '/api/ekis-docs/fin/docs.json',
    selfExReport: '/api/ekis-docs/result/doc.json',
    dataRightsDocs: false,
    dataLocalDocs: false,
    dataPaidAdd: false,
    dataCollAgreement: false,
    dataAkkred: false,
    dataParentPay: false,
    dataEducation: false,
    dataFinDocs: false,
    dataSelfExReport: false,
    dataSampleNotify: false,
    DocsFromApi: false,
    eoId: false,
    goApiToken: false
  },
  mutations: {
    setEoId (state, value) {
      state.eoId = value
    },
    setDataRightsDocs (state, value) {
      state.dataRightsDocs = value
    },
    setDataLocalDocs (state, value) {
      state.dataLocalDocs = value
    },
    setDataAkkred (state, value) {
      state.dataAkkred = value
    },
    setDataPaidAdd (state, value) {
      state.dataPaidAdd = value
    },
    setDataCollAgreement (state, value) {
      state.dataCollAgreement = value
    },
    setDataParentPay (state, value) {
      state.dataParentPay = value
    },
    setDataEducationPaid(state, value){
      state.dataEducation = value
    },
    setDataDocsFromApi(state, value){
      state.DocsFromApi = value
    },
    setDataFinDocs (state, value) {
      state.dataFinDocs = value
    },
    setSelfExReport (state, value) {
      state.dataSelfExReport = value
    },
    [SET_DATA_SAMPLE_NOTIFY] (state, value) {
      state.dataSampleNotify = value
    },
    setGoApiToken (state, value) {
      state.goApiToken = value
    }
  },
  actions: {
    getDataRightsDocs () {
      let path = this.state.api + this.state.rightsDocs + '?eoId=' + this.state.eoId
      Axios({
        method: 'get',
        url: path
      }).then((res) => {
        if (res.status === 200 && res.data.response === 'success') {
          this.commit('setDataRightsDocs', res.data.result)
        }
      })
    },
    getDataLocalDocs ({ state, commit }) {
      return new Promise((resolve, reject) => {
        let path = state.apiGo + state.fileBySlug + state.eoId + '?slug=12,4,5,30,17,18,19,29,27,3,14'
        Axios({
          method: 'get',
          url: path
        }).then((res) => {
          if (res.status === 200 && res.data.response === 'success') {
            commit('setDataLocalDocs', res.data.data)
            resolve(res)
          } else {
            reject(res)
          }
        }).catch((err) => {
          reject(err)
        })
      })
    },
    getDataPaidAdd ({ state, commit }) {
      return new Promise((resolve, reject) => {
        let path = state.api + state.paidAdd + '?eoId=' + state.eoId
        Axios({
          method: 'get',
          url: path
        }).then((res) => {
          if (res.status === 200 && res.data.response === 'success') {
            commit('setDataPaidAdd', res.data.result)
            resolve(res)
          }
        }).catch((err) => {
          reject(err)
        })
      })
    },
    getDataAkkred ({ state, commit }) {
      let path = state.api + state.akkred + '?eoId=' + state.eoId
      Axios({
        method: 'get',
        url: path
      }).then((res) => {
        if (res.status === 200 && res.data.response === 'success') {
          if (res.data.data.hasOwnProperty('accred_table')) {
            commit('setDataAkkred', res.data.data.accred_table)
          }
        }
      })
    },
    getDataCollAgreement ({ state, commit }) {
      return new Promise((resolve, reject) => {
        let path = state.api + state.collAgreement + '?eoId=' + state.eoId + '&names=koldor'
        Axios({
          method: 'get',
          url: path
        }).then((res) => {
          if (res.status === 200 && res.data.response === 'success') {
            commit('setDataCollAgreement', res.data.result)
            resolve(res)
          }
        }).catch((err) => {
          reject(err)
        })
      })
    },
    getDataParentPay ({ state, commit }) {
      return new Promise((resolve, reject) => {
        let path = state.apiGo + state.fileBySlug + state.eoId + '?slug=16'
        Axios({
          method: 'get',
          url: path
        }).then((res) => {
          if (res.status === 200 && res.data.response === 'success') {
            let data = res.data.data
            commit('setDataParentPay', data)
            resolve(res)
          } else {
            reject(res)
          }
        }).catch((err) => {
          reject(err)
        })
      })
    },
    getDataFinDocs ({ state, commit }) {
      return new Promise((resolve, reject) => {
        let path =  state.apiGo + state.fileBySlug + state.eoId + '?slug=36,9,10,8,37'
        Axios({
          method: 'get',
          url: path
        }).then((res) => {
          if (res.data.response === 'success') {
            commit('setDataFinDocs', res.data.data)
            resolve(res)
          } else {
            reject(res)
          }
        }).catch((err) => {
          reject(err)
        })
      })
    },
    getDataEducationPaid ({ state, commit }) {
      return new Promise((resolve, reject) => {
        let path =  state.apiGo + state.fileBySlug + state.eoId + '?slug=10,14,8'
        Axios({
          method: 'get',
          url: path
        }).then((res) => {
          if (res.data.response === 'success') {
            commit('setDataEducationPaid', res.data.data)
            resolve(res)
          } else {
            reject(res)
          }
        }).catch((err) => {
          reject(err)
        })
      })
    },

    getDataDocsFromApi({ state, commit }, data) {
      return new Promise((resolve, reject) => {
        let path =  state.apiGo + state.fileBySlug + state.eoId + '?slug=' + data
        Axios({
          method: 'get',
          url: path
        }).then((res) => {
          if (res.data.response === 'success') {
            commit('setDataDocsFromApi', res.data.data)
            resolve(res)
          } else {
            reject(res)
          }
        }).catch((err) => {
          reject(err)
        })
      })
    },

    getSelfExReport ({ state, commit }) {
      return new Promise((resolve, reject) => {
        let path = state.api + state.selfExReport + '?eoId=' + state.eoId
        Axios({
          method: 'get',
          url: path
        }).then((res) => {
          if (res.data.response === 'success') {
            commit('setSelfExReport', res.data.result)
            resolve(res)
          } else {
            reject(res)
          }
        }).catch((err) => {
          reject(err)
        })
      })
    },
    [GET_SAMPLE_NOTIFY] ({ state, commit }) {
      return ApiService.query('/api/ekis-docs/sample/notify.json?eoId=' + state.eoId).then((res) => {
        if (res.data.response === 'success') {
          commit(SET_DATA_SAMPLE_NOTIFY, res.data.data)
        } else {
          commit(SET_DATA_SAMPLE_NOTIFY, [])
        }
      })
    }
  }
})
